class Signup_Email {
    static path = 'email-actions/signup-email';

    constructor(mutator){
        this.title = 'Add to Email List';
        this.addInput("Determining Condition", "boolean");
        this.addInput("User or Email", "user,user_id,email");
        this.addInput("Email List", "email,email_list");
        this.bgcolor = '#00d1b2';
        this.desc = 'Add a user or email to a specific email list';
    }
}

module.exports = Signup_Email
